import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { updateParker } from '../../services/parkerService';
import { getChargers } from '../../services/chargerService';
import { getPlaces } from '../../services/placeService';

const EditParkerModal = ({ isOpen, onClose, parker, onParkerUpdated }) => {
  const [formData, setFormData] = useState({
    place_id: '',
    charger_id: '',
    location: '',
    charger_type: '',
  });
  const [chargers, setChargers] = useState([]);
  const [places, setPlaces] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [feedback, setFeedback] = useState({ type: '', message: '' });
  const selectedPlaceId = sessionStorage.getItem("selectedPlaceId");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const chargersResponse = await getChargers({ page: 1, per_page: 1000 });
        setChargers(chargersResponse.data);

        if (!selectedPlaceId) {
          const placesResponse = await getPlaces();
          setPlaces(placesResponse.data);
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'Error al cargar datos para el formulario.';
        setFeedback({ type: 'error', message: errorMessage });
      }
    };
    if (isOpen) {
      fetchData();
      if (parker) {
        setFormData({
          place_id: parker.place_id || '',
          charger_id: parker.charger_id || '',
          location: parker.location || '',
          charger_type: parker.charger_type || '',
        });
      }
    }
  }, [isOpen, parker, selectedPlaceId]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    setFeedback({ type: '', message: '' });
    try {
      await updateParker(parker.parker_id, formData);
      setFeedback({ type: 'success', message: 'Parqueadero actualizado correctamente.' });
      setTimeout(() => {
        onParkerUpdated();
        onClose();
      }, 1500);
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Error al actualizar el parqueadero.';
      setFeedback({ type: 'error', message: errorMessage });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Editar Parqueadero</DialogTitle>
      <DialogContent>
        {!selectedPlaceId && (
          <FormControl fullWidth margin="dense">
            <InputLabel>Sede</InputLabel>
            <Select name="place_id" value={formData.place_id} onChange={handleChange}>
              {places.map((place) => (
                <MenuItem key={place.id} value={place.id}>
                  {place.name_place}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <FormControl fullWidth margin="dense">
          <InputLabel>Cargador</InputLabel>
          <Select name="charger_id" value={formData.charger_id} onChange={handleChange}>
            {chargers.map((d) => (
              <MenuItem key={d.charger_id} value={d.charger_id}>
                ID: {d.charger_id}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          margin="dense"
          name="location"
          label="Ubicación"
          type="text"
          fullWidth
          variant="standard"
          value={formData.location}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="charger_type"
          label="Tipo de Cargador"
          type="text"
          fullWidth
          variant="standard"
          value={formData.charger_type}
          onChange={handleChange}
        />
        {feedback.message && (
          <Alert severity={feedback.type} sx={{ mt: 2 }}>
            {feedback.message}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? <CircularProgress size={24} /> : 'Actualizar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditParkerModal;
